import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getTomatoCount, getTomatoCountSync, initializeTomatoCounts, subscribeToTomatoCount } from '../utils/tomatoManagerV2';

/**
 * TomatoCounter component
 * Displays the current tomato count for a user
 */
function TomatoCounter() {
  const { currentUser } = useAuth();
  const [count, setCount] = useState(10); // Default to 10
  const [loading, setLoading] = useState(true);
  
  // Get and update the tomato count
  useEffect(() => {
    const userId = currentUser?.uid || 'anonymous_user';
    let unsubscribe = () => {};
    
    // Get initial count from cache first (sync)
    const cachedCount = getTomatoCountSync(userId);
    setCount(cachedCount);
    
    // Initialize and fetch from Firebase
    const initialize = async () => {
      try {
        await initializeTomatoCounts(userId);
        const currentCount = await getTomatoCount(userId);
        setCount(currentCount);
        setLoading(false);
        
        // Subscribe to real-time updates
        unsubscribe = subscribeToTomatoCount(userId, (newCount) => {
          setCount(newCount);
        });
      } catch (error) {
        console.error('Error initializing tomato count:', error);
        setLoading(false);
      }
    };
    
    initialize();
    
    // Listen for count changes (legacy support)
    const handleTomatoCountChanged = (e) => {
      const { userId: eventUserId, count: newCount } = e.detail;
      if (eventUserId === userId) {
        setCount(newCount);
      }
    };
    
    // Add event listener
    document.addEventListener('tomatoCountChanged', handleTomatoCountChanged);
    
    // Clean up
    return () => {
      document.removeEventListener('tomatoCountChanged', handleTomatoCountChanged);
      unsubscribe();
    };
  }, [currentUser]);
  
  return (
    <div style={{
      display: 'inline-block',
      backgroundColor: count === 0 ? '#666' : '#FF6B00',
      color: 'white',
      fontWeight: 'bold',
      padding: '3px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      cursor: count === 0 ? 'pointer' : 'default',
      transition: 'all 0.2s ease'
    }}
    onClick={() => {
      if (count === 0) {
        // Trigger the refill modal
        window.dispatchEvent(new CustomEvent('openTomatoRefillModal'));
      }
    }}
    title={count === 0 ? 'Click to get more tomatoes' : `${count} tomatoes left`}
    >
      🍅 {count} {count === 0 && '(Get more)'}
    </div>
  );
}

export default TomatoCounter;